/* eslint-disable max-len */
import React, { Fragment, useEffect, useState } from 'react'
import TableBody from './TableBody'
import extractMonthYearInRange from '../../../../../CommonMethods/extractMonthYearInRange';

export default function YearTable({ recodes, searchParams, pageNumber, pageType, List, emptyScreenMessage }) {
    const [monthDorpDown, setMonthDropDown] = useState([]);

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to calculate and set the month dropdown options based on the
    `start_date` and `end_date` values from the `searchParams` object. */
    useEffect(() => {

        let array = extractMonthYearInRange(searchParams.get("start_date"), searchParams.get("end_date"))
        const filteredDates = array.filter(dateStr => {
            // Convert the date string to a JavaScript Date object
            const date = new Date(`${dateStr} 01`);
            // Get the current date
            const currentDate = new Date();

            // Check if the date is before or equal to the current date
            return date <= currentDate;
        });
        setMonthDropDown(filteredDates)
    }, [])

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;
    const isEmptyList = (List?.data?.length === 0 || List?.total_count === 0 || emptyScreenMessage === "No data found" || noSearchOrFilter);

    return (
        <>
            <div className='-mx-1'>
                <div className={`flex overflow-auto ${isEmptyList || List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1`} id="search-result" >
                    <table aria-label="Outside Table" class="w-full auto-layout" id="admin-table">
                        <thead>
                            <tr>
                                <th class="min-w-[160px]">
                                    <span >
                                        {pageType === "staff" ? "Employee" : "Student"} ID
                                    </span>
                                </th>
                                <th class="min-w-[200px]">
                                    <span >{pageType === "staff" ? "Employee" : "Student"} Name
                                    </span>
                                </th>
                                <th class={`${pageType === "staff" ? 'min-w-[140px]': 'min-w-[80px]'} `}>
                                    <span >{pageType === "staff" ? "Type" : "Gender"}
                                    </span>
                                </th>
                                <th class="min-w-[400px]" colspan="4">
                                    <span class="flex items-center justify-center">Attendance Summary
                                    </span>
                                </th>
                                {!isEmptyList && monthDorpDown?.length > 0 ? (
                                    monthDorpDown?.map((item, index) => (
                                        <th class={`min-w-[110px] ${monthDorpDown?.length === index + 1 ? "" : ""}`} key={index + 'year'}>
                                            <span class={`flex items-center justify-end `}>{item}
                                            </span>
                                        </th>
                                    ))
                                ) : (
                                    <th class="min-w-[110px]" colspan="3">
                                        <span class="flex items-center justify-center">Month 1</span>
                                    </th>
                                )}
                            </tr>
                            <tr aria-colspan="7" class="h-1">
                            </tr>
                        </thead>
                        <tbody>
                            <tr id="secondHeader">
                                <td class="text-start"></td>
                                <td class="text-start"></td>
                                <td class="text-start"></td>
                                <td class="text-end border-l border-[#EDEDED] min-w-[126px] font-semibold">Total Days</td>
                                <td class="text-end font-semibold">Present</td>
                                <td class="text-end font-semibold">Percentage</td>
                                <td class="text-end font-semibold">Absent</td>
                                {!isEmptyList && monthDorpDown?.length > 0 ? (
                                    monthDorpDown?.map((item, index) => (
                                        <td class={`text-center ${index === 0 ? "border-l border-[#EDEDED]" : index + 1 === monthDorpDown?.length ? "" : ""}`} key={index + "itemname"}></td>
                                    ))
                                ) : (
                                    <td class={`border-l border-[#EDEDED] text-center`}></td>
                                )}
                            </tr>
                            
                            {
                                recodes?.map((item) => (
                                    <Fragment key={item.student_id}>
                                        <TableBody tableItem={item} monthDorpDown={monthDorpDown} pageType={pageType} />
                                    </Fragment>
                                ))}
                        </tbody>
                        {(isEmptyList) && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px'}} colspan="8" className="no-records-message"  id='no-matching-result'>
                                        {noSearchOrFilter ? (pageType === "staff" ? `Select 'Financial Year' and 'Employee Type' to view Employee Attendance.`:`Select 'Academic Year', 'Class', and 'Section' to view Student Attendance.`) : 'No matching records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    )
}
